import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";
import { defaultKSK1070_R01DetailDto, defaultKSK1070_R01HeaderDto, defaultKSK1070_R01LotDto, KSK1070_R01DetailDto, KSK1070_R01HeaderDto, KSK1070_R01LotDto } from './Dto_KSK1070_R01';
import { showWarning } from 'src/utils/toast/toastUtil';
import { getFutureWeekdayExceptTodayAndTomorrow } from 'src/utils/date/dateUtils';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { buildLotsByPackQty, buildLotsByPurchaseLotAndPackQty } from 'src/utils/wms/buildLotsByPackQty';


export interface KSK1070_R01Filter {
	dateRange: DateRange | undefined;
	wmsOrderNo: string;
	customCd: string;
	customNm: string;
	labelPrintAuto: string;
}

export interface Store_KSK1070_R01 {
	KSK1070_R01Filter: KSK1070_R01Filter;
	KSK1070_R01PastFilter: KSK1070_R01Filter;
	setKSK1070_R01Filter: (filter: Partial<Store_KSK1070_R01['KSK1070_R01Filter']>) => void;
	setKSK1070_R01PastFilter: (filter: Store_KSK1070_R01['KSK1070_R01PastFilter']) => void;

	// ====== 매출 리스트 및 선택/편집 ======
	editKSK1070_R01: KSK1070_R01HeaderDto | null;
	setEditKSK1070_R01: (editSale: KSK1070_R01HeaderDto | null) => void;

	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedKSK1070_R01DetailList: string[];
	setDeletedKSK1070_R01DetailList: (idList: string[]) => void;
	addDeletedKSK1070_R01DetailList: (idList: string[]) => void;
	removeDeletedKSK1070_R01DetailList: (idList?: string[]) => void;

	// ====== 매출 상세(디테일) 데이터 ======
	KSK1070_R01DetailList: KSK1070_R01DetailDto[];
	setKSK1070_R01DetailList: (data: KSK1070_R01DetailDto[]) => void;
	insertKSK1070_R01DetailList: (data: KSK1070_R01DetailDto[], index?: number) => void;
	removeKSK1070_R01DetailList: (index: number) => void;
	updateKSK1070_R01DetailList: (index: number, data: KSK1070_R01DetailDto) => void;

	// ====== 선택(디테일) 행 선택/삭제 관리 ======
	selectedKSK1070_R01DetailList: string[];
	setSelectedKSK1070_R01DetailList: (idList: string[]) => void;
	addSelectedKSK1070_R01DetailList: (idList: string[]) => void;
	removeSelectedKSK1070_R01DetailList: (idList?: string[]) => void;
	initSelectedKSK1070_R01DetailList: () => void;

	originalKSK1070_R01DetailList: KSK1070_R01DetailDto[];
	setOriginalKSK1070_R01DetailList: (data: KSK1070_R01DetailDto[]) => void;

	// ====== 입고 상세(lot) 데이터 ======
	KSK1070_R01LotMap: Map<string, KSK1070_R01LotDto[]>;
	setKSK1070_R01LotMap: (data: Map<string, KSK1070_R01LotDto[]>) => void;
	
	selectedItemCdForLot: string | null;
	setSelectedItemCdForLot: (itemCd: string | null) => void;

	lotTotalQty: number;
	syncLotTotalQtyFromSelectedDetail: () => void;
	setLotTotalQty: (qty: number) => void;
	applyLotTotalQty: (qty: number) => boolean;

	purchaseLotNo: string;
	setPurchaseLotNo: (purchaseLotNo: string) => void;
	appliedLotTotalQtyItemCds: string[];
	
	// LotTable의 핸들러들을 위한 함수. 현재 선택된 아이템의 Lot 리스트를 업데이트합니다.
	setKSK1070_R01LotList: (data: KSK1070_R01LotDto[]) => void;

	insertKSK1070_R01LotList: (data: KSK1070_R01LotDto[], index?: number) => void;
	resetKSK1070_R01LotList: (KSK1070_R01DetailList : KSK1070_R01DetailDto[]) => Promise<void>;
	removeKSK1070_R01LotList: (valueIndex: number) => void;	
	updateKSK1070_R01LotList: (valueIndex: number, data: KSK1070_R01LotDto) => void;

	// ====== 입고 상세선택(lot) 행 선택/삭제 관리 ======
	selectedKSK1070_R01LotList: string[];
	setSelectedKSK1070_R01LotList: (idList: string[]) => void;
	addSelectedKSK1070_R01LotList: (idList: string[]) => void;
	removeSelectedKSK1070_R01LotList: (idList?: string[]) => void;
	initSelectedKSK1070_R01LotList: () => void;

	// ====== 입고 상세(lot) 행 선택/삭제 관리 ======
	deletedKSK1070_R01LotList: string[];
	setDeletedKSK1070_R01LotList: (idList: string[]) => void;
	addDeletedKSK1070_R01LotList: (idList: string[]) => void;
	removeDeletedKSK1070_R01LotList: (idList?: string[]) => void;

	originalKSK1070_R01LotList: KSK1070_R01LotDto[];
	setOriginalKSK1070_R01LotList: (data: KSK1070_R01LotDto[]) => void;

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;

	lotColumnState: ColumnState[] | null;
	setLotColumnState: (state: ColumnState[] | null) => void;
	
	allCount: number;				setAllCount: (allCount: number) => void;
	

	transportComplete: boolean;		setTransportComplete: (transportComplete: boolean) => void;
	detailFetchTrigger: boolean;	setDetailFetchTrigger: (detailFetchTrigger: boolean) => void;
	lotFetchTrigger: boolean;		setLotFetchTrigger: (lotFetchTrigger: boolean) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;
	lotScrollTop: number | null;
	setLotScrollTop: (top: number | null) => void;

	// ====== 초기화 ======
	initData: () => void;

	// ====== 유효성 검사 및 동기화 ======
	validateAndSyncLotQty: () => void;
	// 입고합계가 0일 때 첫번째 LOT 수량 자동 설정
	setAutoLotQtyIfEmpty: (detailRow: KSK1070_R01DetailDto) => void;
	// 창고 코드 필터링 (로직센터 & 자재창고 여부)
	warehouseCdListToUseList: (logicCenter: string) => WareHouseDto[];
	// 공통코드 로드 후 초기값 동기화
	syncInitialData: () => void;

}

const findSelectedDetail = (
	detailList: KSK1070_R01DetailDto[],
	selectedDetailList: string[],
): KSK1070_R01DetailDto | undefined => {
	if (!selectedDetailList.length) return undefined;
	const selectedValueIndex = selectedDetailList[0]?.toString();
	return detailList.find(d => d.valueIndex.toString() === selectedValueIndex);
};

const resolveLotTotalQtyFromDetail = (detail: KSK1070_R01DetailDto | undefined): number => {
	if (!detail) return 0;
	return detail.updateTransportQty > 0 ? detail.updateTransportQty : detail.orderQtyView;
};

const calculateTotalProductQty = (lotList: KSK1070_R01LotDto[], deletedList: string[]): number => {
	return lotList.reduce((sum, item) => {
		if (deletedList.includes(item.valueIndex.toString())) {
			return sum;
		}
		return sum + (Number(item.lotQty) || 0);
	}, 0);
};

export const defaultKSK1070_R01Filter: KSK1070_R01Filter = {
	dateRange: {
		from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
		to: getFutureWeekdayExceptTodayAndTomorrow(),
	},
	wmsOrderNo: '',
	customCd: '',
	customNm: '',
	labelPrintAuto: 'N',
};

const getInitialKSK1070_R01HeaderDto = (): KSK1070_R01HeaderDto => {
	const { wmsCdList, warehouseCdList } = useCommonCodeStore.getState();
	return {
		...defaultKSK1070_R01HeaderDto,
		logicCenter: wmsCdList?.[0]?.minorCd || '',
		warehouseCd: warehouseCdList?.[0]?.warehouseCd || '',
		warehouseNm: warehouseCdList?.[0]?.warehouseNm || '',
	};
};

export const useKSK1070_R01Store = create<Store_KSK1070_R01>((set, get) => ({
	KSK1070_R01Filter: defaultKSK1070_R01Filter,
	KSK1070_R01PastFilter: defaultKSK1070_R01Filter,
	setKSK1070_R01Filter: (update) => set((state) => ({
		KSK1070_R01Filter: {
			...state.KSK1070_R01Filter,
			...update,
		},
	})),
	setKSK1070_R01PastFilter: (filter) => set({
		KSK1070_R01PastFilter: filter,
	}),

	// ====== 매출 리스트 및 선택/편집 ======
	editKSK1070_R01: getInitialKSK1070_R01HeaderDto(),
	setEditKSK1070_R01: (editSale: KSK1070_R01HeaderDto | null) => set((state) => {
		return {
			...state,
			editKSK1070_R01: editSale
		}
	}),

	// ====== 매출 상세(디테일) 데이터 ======
	KSK1070_R01DetailList: [],
	setKSK1070_R01DetailList: (data: KSK1070_R01DetailDto[]) => set((state) => {
		let newList: KSK1070_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				//...defaultKSK1070_R01DetailDto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			KSK1070_R01DetailList: newList
		}
	}),
	insertKSK1070_R01DetailList: (data: KSK1070_R01DetailDto[], index?: number) => set((state) => {
		let newKSK1070_R01DetailList = [...state.KSK1070_R01DetailList];

		let targetRowData = newKSK1070_R01DetailList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newKSK1070_R01DetailList.map(item => item.valueIndex || 0)) + 1;

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newKSK1070_R01DetailList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newKSK1070_R01DetailList = newKSK1070_R01DetailList.filter(item => item.orderIndex !== targetOrderIndex);
		newKSK1070_R01DetailList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultKSK1070_R01DetailDto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newKSK1070_R01DetailList.splice(index, 0, ...newData);
		} else {
			newKSK1070_R01DetailList.push(...newData);
		}

		return {
			...state,
			KSK1070_R01DetailList: newKSK1070_R01DetailList
		}
	}),
	removeKSK1070_R01DetailList: (index: number) => set((state) => {
		const newKSK1070_R01DetailList = [...state.KSK1070_R01DetailList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			KSK1070_R01DetailList: newKSK1070_R01DetailList
		}
	}),
	updateKSK1070_R01DetailList: (valueIndex: number, data: KSK1070_R01DetailDto) => set((state) => {
		const _KSK1070_R01DetailList = state.KSK1070_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		return {
			...state,
			KSK1070_R01DetailList: _KSK1070_R01DetailList
		}
	}),
	
	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedKSK1070_R01DetailList: [],
	setDeletedKSK1070_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedKSK1070_R01DetailList: idList
		}
	}),
	addDeletedKSK1070_R01DetailList: (idList: string[]) => set((state) => {
		const _deletedDetailList = [...state.deletedKSK1070_R01DetailList];

		for(const valueIndex of idList) {
			const isInserted = state.KSK1070_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.KSK1070_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedDetailList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedKSK1070_R01DetailList: _deletedDetailList
		}
	}),
	removeDeletedKSK1070_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedKSK1070_R01DetailList: [...state.deletedKSK1070_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedKSK1070_R01DetailList: [],
	setSelectedKSK1070_R01DetailList: (idList: string[]) => {
		set((state) => {
			const selectedDetail = findSelectedDetail(state.KSK1070_R01DetailList, idList);
			const firstItemCd = selectedDetail?.itemCd || null;

			return {
				...state,
				selectedKSK1070_R01DetailList: idList,
				selectedItemCdForLot: firstItemCd,
				lotFetchTrigger: true,
				lotScrollTop: null,
				lotTotalQty: resolveLotTotalQtyFromDetail(selectedDetail),
				purchaseLotNo: '',
			}
		});

		const selectedDetail = findSelectedDetail(get().KSK1070_R01DetailList, idList);
		if (selectedDetail && selectedDetail.updateTransportQty === 0) {
			get().setAutoLotQtyIfEmpty(selectedDetail);
		}
	},
	addSelectedKSK1070_R01DetailList: (idList: string[]) => set((state) => {
		const _selectedKSK1070_R01DetailList = [...state.selectedKSK1070_R01DetailList];
		if(idList.length > 0) {
			_selectedKSK1070_R01DetailList.push(...idList);
		}
		return {
			...state,
			selectedKSK1070_R01DetailList: _selectedKSK1070_R01DetailList
		}
	}),
	removeSelectedKSK1070_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedKSK1070_R01DetailList: [...state.selectedKSK1070_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedKSK1070_R01DetailList: () => set({ selectedKSK1070_R01DetailList: [], lotFetchTrigger: false, lotTotalQty: 0, purchaseLotNo: '' }),

	originalKSK1070_R01DetailList: [],
	setOriginalKSK1070_R01DetailList: (data: KSK1070_R01DetailDto[]) => set((state) => {
		let newList: KSK1070_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultKSK1070_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalKSK1070_R01DetailList: newList
		}
	}),

	// ====== 입고 상세(lot) 데이터 ======
	KSK1070_R01LotMap: new Map<string, KSK1070_R01LotDto[]>(),
	setKSK1070_R01LotMap: (data: Map<string, KSK1070_R01LotDto[]>) => set({ KSK1070_R01LotMap: data }),

	selectedItemCdForLot: null,
	setSelectedItemCdForLot: (itemCd) => set({ selectedItemCdForLot: itemCd }),

	lotTotalQty: 0,
	setLotTotalQty: (qty) => set({ lotTotalQty: Math.max(0, Number(qty) || 0) }),
	purchaseLotNo: '',
	setPurchaseLotNo: (purchaseLotNo) => set({ purchaseLotNo }),
	appliedLotTotalQtyItemCds: [],
	// 선택 품목의 입고합계/주문잔량을 오른쪽 주문잔량 입력칸에 맞춘다.
	syncLotTotalQtyFromSelectedDetail: () => {
		const state = get();
		const selectedDetail = findSelectedDetail(state.KSK1070_R01DetailList, state.selectedKSK1070_R01DetailList);
		set({ lotTotalQty: resolveLotTotalQtyFromDetail(selectedDetail) });
	},
	// 이번 구매 Lot 수량(x)을 packQty로 나눠 행을 추가한다. 기존 구매 Lot 행은 유지한다.
	applyLotTotalQty: (qty: number) => {
		const state = get();
		const selectedDetail = findSelectedDetail(state.KSK1070_R01DetailList, state.selectedKSK1070_R01DetailList);

		if (!selectedDetail?.itemCd) {
			showWarning('품목을 선택해주세요.');
			return false;
		}

		const normalizedQty = Math.max(0, Number(qty) || 0);
		const maxQty = selectedDetail.orderQtyView;
		const itemCd = selectedDetail.itemCd;
		const isFirstApply = !state.appliedLotTotalQtyItemCds.includes(itemCd);
		const existingLots = (state.KSK1070_R01LotMap.get(itemCd) || []).filter(
			(lot) => !state.deletedKSK1070_R01LotList.includes(lot.valueIndex.toString()),
		);
		const keptSum = isFirstApply
			? 0
			: existingLots.reduce((sum, lot) => sum + (Number(lot.lotQty) || 0), 0);

		if (keptSum + normalizedQty > maxQty) {
			showWarning(`입고량이 주문잔량(${maxQty})보다 클 수 없습니다.`);
			get().syncLotTotalQtyFromSelectedDetail();
			return false;
		}

		const baseLot: KSK1070_R01LotDto = {
			...defaultKSK1070_R01LotDto,
			itemCd,
			lotInputOption: 'N',
			printed: false,
			inserted: true,
		};

		const { lots, error } = buildLotsByPurchaseLotAndPackQty({
			existingLots,
			totalQty: normalizedQty,
			packQty: selectedDetail.packQty,
			purchaseLotNo: state.purchaseLotNo,
			baseLot,
			isFirstApply,
		});

		if (error) {
			showWarning(error);
			return false;
		}

		const newLotMap = new Map(state.KSK1070_R01LotMap);
		newLotMap.set(itemCd, lots);

		const appliedQty = lots.reduce((sum, lot) => sum + (Number(lot.lotQty) || 0), 0);
		const newDetailList = state.KSK1070_R01DetailList.map(item =>
			item.valueIndex === selectedDetail.valueIndex
				? { ...item, updateTransportQty: appliedQty }
				: item
		);

		set({
			KSK1070_R01LotMap: newLotMap,
			KSK1070_R01DetailList: newDetailList,
			lotTotalQty: 0,
			purchaseLotNo: '',
			appliedLotTotalQtyItemCds: isFirstApply
				? [...state.appliedLotTotalQtyItemCds, itemCd]
				: state.appliedLotTotalQtyItemCds,
			deletedKSK1070_R01LotList: state.deletedKSK1070_R01LotList.filter((valueIndex) =>
				!existingLots.some((lot) => lot.valueIndex.toString() === valueIndex),
			),
		});
		return true;
	},

	setKSK1070_R01LotList: (data: KSK1070_R01LotDto[]) => set((state) => {
		const { KSK1070_R01LotMap, selectedItemCdForLot } = state;
		if (!selectedItemCdForLot) return state; // 선택된 아이템이 없으면 아무것도 하지 않음

		const newLotMap = new Map(KSK1070_R01LotMap);
		newLotMap.set(selectedItemCdForLot, data);

		return { KSK1070_R01LotMap: newLotMap };
	}),

	insertKSK1070_R01LotList: async (data: KSK1070_R01LotDto[], index?: number) => {
		const state = get();
		const { KSK1070_R01LotMap, selectedItemCdForLot } = state;
		
		// 1. 데이터 그룹화 (itemCd 기준)
		const dataByItem = new Map<string, KSK1070_R01LotDto[]>();
		data.forEach(item => {
			const targetItemCd = item.itemCd || selectedItemCdForLot;
			if (targetItemCd) {
				const list = dataByItem.get(targetItemCd) || [];
				list.push({ ...item, itemCd: targetItemCd });
				dataByItem.set(targetItemCd, list);
			}
		});

		if (dataByItem.size === 0) return;

		const newLotMap = new Map(KSK1070_R01LotMap);

		// 2. 각 아이템 그룹별로 처리 (기존 생성 로직)
		for (const [itemCd, items] of Array.from(dataByItem.entries())) {
			let targetList = [...(newLotMap.get(itemCd) || [])];
			
			// 기준 행 찾기 (index는 valueIndex라고 가정)
			const pivotRow = (index !== undefined) ? targetList.find(r => r.valueIndex === index) : null;
			
			// 기준 값 설정
			let targetOrderIndex = 1;
			let startSeq = 1;
			
			if (pivotRow) {
				targetOrderIndex = pivotRow.orderIndex;
				startSeq = pivotRow.orderIndexSeq + 1;
				
				// 기존 행들 중 pivotRow 뒤에 오는 행들의 Seq 밀기
				targetList.forEach(row => {
					if (row.orderIndex === targetOrderIndex && row.orderIndexSeq >= startSeq) {
						row.orderIndexSeq += items.length;
					}
				});
			} else if (targetList.length > 0) {
				// 기준 행 없으면 마지막 행 기준
				const last = targetList[targetList.length - 1];
				targetOrderIndex = last.orderIndex;
				startSeq = last.orderIndexSeq + 1;
			}

			newLotMap.set(itemCd, targetList);
		}

		if(selectedItemCdForLot) {
			const targetList = newLotMap.get(selectedItemCdForLot) || [];
			const last = targetList[targetList.length - 1];
			const maxValueIndex = last?.valueIndex || 0;

			//새 행 입력
			const newLow = {
				...defaultKSK1070_R01LotDto,
				valueIndex: maxValueIndex + 1,
				orderIndex: last?.orderIndex || 0,
				orderIndexSeq: maxValueIndex + 1,
				itemCd: selectedItemCdForLot,
				printed: false,
				inserted: true,
			};
			newLotMap.set(selectedItemCdForLot, [...(newLotMap.get(selectedItemCdForLot) || []), newLow]);
		}

		set({ KSK1070_R01LotMap: newLotMap });
		get().validateAndSyncLotQty();
	},

	resetKSK1070_R01LotList: async (KSK1070_R01DetailList : KSK1070_R01DetailDto[]) => {
		const newLotMap = new Map<string, KSK1070_R01LotDto[]>();
		if(!KSK1070_R01DetailList || KSK1070_R01DetailList.length === 0) {
			set({ KSK1070_R01LotMap: newLotMap, appliedLotTotalQtyItemCds: [], purchaseLotNo: '' });
			return;
		}

		for (const item of KSK1070_R01DetailList) {
			if (!item.itemCd) continue;

			const baseLot: KSK1070_R01LotDto = {
				...defaultKSK1070_R01LotDto,
				itemCd: item.itemCd,
				purchaseLotNo: '',
				lotInputOption: 'N',
				printed: false,
				inserted: true,
			};

			const lots = buildLotsByPackQty(item.orderQtyView, item.packQty, baseLot);
			newLotMap.set(item.itemCd, lots);
		}

		set({
			KSK1070_R01LotMap: newLotMap,
			appliedLotTotalQtyItemCds: [],
			purchaseLotNo: '',
		});
		get().validateAndSyncLotQty();
		get().syncLotTotalQtyFromSelectedDetail();
	},

	removeKSK1070_R01LotList: (valueIndex: number) => {
		set((state) => {
			const { KSK1070_R01LotMap, selectedItemCdForLot } = state;
			if (!selectedItemCdForLot) return state;

			const newLotMap = new Map(KSK1070_R01LotMap);
			const targetList = (newLotMap.get(selectedItemCdForLot) || []).filter(item => item.valueIndex !== valueIndex);
			
			newLotMap.set(selectedItemCdForLot, targetList);
			return { KSK1070_R01LotMap: newLotMap };
		});
		get().validateAndSyncLotQty();
	},

	updateKSK1070_R01LotList: (valueIndex: number, data: KSK1070_R01LotDto) => {
		set((state) => {
			const { KSK1070_R01LotMap, selectedItemCdForLot } = state;
			if (!selectedItemCdForLot) return state;

			if(data.lotQty < 0) {
				showWarning('입고량은 0보다 작을 수 없습니다.');
				data.lotQty = 0;
			}

			const newLotMap = new Map(KSK1070_R01LotMap);
			const targetList = (newLotMap.get(selectedItemCdForLot) || []).map(item =>
				item.valueIndex === valueIndex ? data : item
			);

			newLotMap.set(selectedItemCdForLot, targetList);
			return { KSK1070_R01LotMap: newLotMap };
		});
		get().validateAndSyncLotQty();
	},
	
	// ====== 입고 상세(lot) 행 선택/삭제 관리 ======
	deletedKSK1070_R01LotList: [],
	setDeletedKSK1070_R01LotList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedKSK1070_R01LotList: idList
		}
	}),
	addDeletedKSK1070_R01LotList: (idList: string[]) => {
		set((state) => {
			const _deletedLotList = [...state.deletedKSK1070_R01LotList];
			const selectedItemCd = state.KSK1070_R01DetailList.map(item => item.itemCd)[0];
			const newKSK1070_R01LotList = [...state.KSK1070_R01LotMap.get(selectedItemCd) || []];

			for(const valueIndex of idList) {
				const isInserted = newKSK1070_R01LotList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
				const isModified = newKSK1070_R01LotList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
				if(!isInserted && !isModified) {
					_deletedLotList.push(valueIndex);
				}
			}
			
			return {
				...state,
				deletedKSK1070_R01LotList: _deletedLotList,
			}
		});
		get().validateAndSyncLotQty();
	},
	removeDeletedKSK1070_R01LotList: (idList?: string[]) => {
		set((state) => ({
			...state,
			deletedKSK1070_R01LotList: [...state.deletedKSK1070_R01LotList].filter(value => idList ? !idList.includes(value) : false)
		}));
		get().validateAndSyncLotQty();
	},

	selectedKSK1070_R01LotList: [],
	setSelectedKSK1070_R01LotList: (idList: string[]) => {
		set((state) => {
			return {
				...state,
				selectedKSK1070_R01LotList: idList,
			}
		});
		get().validateAndSyncLotQty();
	},
	addSelectedKSK1070_R01LotList: (idList: string[]) => set((state) => {
		const _selectedKSK1070_R01LotList = [...state.selectedKSK1070_R01LotList];
		if(idList.length > 0) {
			_selectedKSK1070_R01LotList.push(...idList);
		}
		return {
			...state,
			selectedKSK1070_R01LotList: _selectedKSK1070_R01LotList
		}
	}),
	removeSelectedKSK1070_R01LotList: (idList?: string[]) => set((state) => ({
		...state,
		selectedKSK1070_R01LotList: [...state.selectedKSK1070_R01LotList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedKSK1070_R01LotList: () => set({ selectedKSK1070_R01LotList: [] }),	

	originalKSK1070_R01LotList: [],
	setOriginalKSK1070_R01LotList: (data: KSK1070_R01LotDto[]) => set((state) => {
		let newList: KSK1070_R01LotDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultKSK1070_R01LotDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalKSK1070_R01LotList: newList
		}
	}),

	// ====== 컬럼 상태(그리드) ======
	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),

	detailColumnState: null,
	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),

	lotColumnState: null,
	setLotColumnState: (state: ColumnState[] | null) => set({ lotColumnState: state }),
	
	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
						

	transportComplete: false,		setTransportComplete: (transportComplete: boolean) => set({ transportComplete }),
	detailFetchTrigger: false,		setDetailFetchTrigger: (detailFetchTrigger: boolean) => set({ detailFetchTrigger }),
	lotFetchTrigger: false,			setLotFetchTrigger: (lotFetchTrigger: boolean) => set({ lotFetchTrigger }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),
	lotScrollTop: null,
	setLotScrollTop: (top: number | null) => set({ lotScrollTop: top }),

	// ====== 초기화 ======
	initData: () => {
		set((state) => ({
		...state,

		KSK1070_R01Filter: defaultKSK1070_R01Filter,
		KSK1070_R01PastFilter: defaultKSK1070_R01Filter,

		KSK1070_R01LotMap: new Map<string, KSK1070_R01LotDto[]>(),
		originalKSK1070_R01LotList: [],
		selectedItemCdForLot: null,

		
		KSK1070_R01DetailList: [],
		deletedKSK1070_R01DetailList: [],
		selectedKSK1070_R01DetailList: [],
		originalKSK1070_R01DetailList: [],
		editKSK1070_R01: getInitialKSK1070_R01HeaderDto(),
		allCount: 0,
		

		transportComplete: false,
		detailFetchTrigger: false,
		lotFetchTrigger: false,
		scrollTop: null,
		detailScrollTop: null,
		lotScrollTop: null,
		lotTotalQty: 0,
		purchaseLotNo: '',
		appliedLotTotalQtyItemCds: [],
	}))},

	//입고합계가 0인 DetailRow가 있을 때 자동으로 LOT 수량을 설정
	setAutoLotQtyIfEmpty: (detailRow: KSK1070_R01DetailDto) => {
		const state = get();
		const { KSK1070_R01LotMap } = state;

		const itemCd = detailRow.itemCd;
		if (!itemCd) return;

		const existingLots = KSK1070_R01LotMap.get(itemCd) || [];
		const existingSum = existingLots.reduce((sum, lot) => sum + (Number(lot.lotQty) || 0), 0);

		// 입고합계가 이미 있거나, 유효한 LOT이 있으면 유지
		if (detailRow.updateTransportQty !== 0 && existingSum > 0) return;

		const baseLot: KSK1070_R01LotDto = {
			...defaultKSK1070_R01LotDto,
			itemCd,
			purchaseLotNo: '',
			lotInputOption: 'N',
			printed: false,
			inserted: true,
		};

		const totalQty = detailRow.updateTransportQty > 0
			? detailRow.updateTransportQty
			: detailRow.orderQtyView;

		const newLotList = buildLotsByPackQty(totalQty, detailRow.packQty, baseLot);
		const newMap = new Map(KSK1070_R01LotMap);
		newMap.set(itemCd, newLotList);

		set({ KSK1070_R01LotMap: newMap });
		setTimeout(() => get().validateAndSyncLotQty(), 0);
	},

	warehouseCdListToUseList: (logicCenter: string) => {
		const { warehouseCdList } = useCommonCodeStore.getState();
		const filteredList = warehouseCdList.filter(value => (value.logicCenter === logicCenter
			&& (value.materialYn === 'Y')
		));
		
		if (filteredList.length === 0) {
			return [{ warehouseCd: '', warehouseNm: '' } as WareHouseDto];
		}
		
		return filteredList;
	},

	syncInitialData: () => {
		const { wmsCdList } = useCommonCodeStore.getState();
		const state = get();
		
		// 이미 값이 있거나 공통코드가 없으면 리턴
		if ((state.editKSK1070_R01?.logicCenter && state.editKSK1070_R01?.warehouseCd) || wmsCdList.length === 0) return;

		const defaultLogicCenter = wmsCdList?.[0]?.minorCd || '';
		
		// 스토어 내부 함수를 사용하여 유효한 창고 목록을 가져옴
		const availableWarehouses = state.warehouseCdListToUseList(defaultLogicCenter);
		const defaultWarehouseCd = availableWarehouses?.[0]?.warehouseCd || '';
		const defaultWarehouseNm = availableWarehouses?.[0]?.warehouseNm || '';

		set((state) => ({
			editKSK1070_R01: {
				...state.editKSK1070_R01!,
				logicCenter: defaultLogicCenter,
				warehouseCd: defaultWarehouseCd,
				warehouseNm: defaultWarehouseNm,
			}
		}));
	},

	validateAndSyncLotQty: () => {
		const state = get();
		const { KSK1070_R01LotMap, KSK1070_R01DetailList, deletedKSK1070_R01LotList } = state;
		
		const lotQtySums = new Map<string, number>();
		const crashItems = new Map<string, number>(); // itemCd -> crashIndex

		let valid = true;

		KSK1070_R01LotMap.forEach((lots, itemCd) => {
			// 주문잔량(orderQtyView) 기준으로 한도 검증 — applyLotTotalQty와 동일
			const detailItem = KSK1070_R01DetailList.find(d => d.itemCd === itemCd);
			const maxQty = detailItem
				? (Number(detailItem.orderQtyView) || Number(detailItem.orderQty) || 0)
				: 0;

			let currentSum = 0;
			let crashIndex = -1;

			// Lot들을 순회하며 합계 계산 및 초과 지점 탐색
			lots.forEach((lot, index) => {
				// 삭제된 lot은 계산에서 제외
				if (deletedKSK1070_R01LotList.includes(lot.valueIndex.toString())) {
					return;
				}

				const qty = Number(lot.lotQty || 0);
				// 현재까지의 합계 + 이번 lot수량이 주문량을 초과하면
				if (currentSum + qty > maxQty) {
					// 아직 범인을 못 찾았고, 수량이 0보다 큰 경우
					if (crashIndex === -1 && qty > 0) {
						crashIndex = index;
						valid = false;
						showWarning(`입고량이 주문량(${maxQty})보다 클 수 없습니다. - 품목코드: ${itemCd}`);
					}
				}
				currentSum += qty;
			});

			lotQtySums.set(itemCd, currentSum);
			if (crashIndex !== -1) {
				crashItems.set(itemCd, crashIndex);
			}
		});

		//valid가 false면 문제가 생긴 행의 입고량을 0으로 설정
		if (!valid && crashItems.size > 0) {
			const newLotMap = new Map(KSK1070_R01LotMap);
			let isUpdated = false;

			crashItems.forEach((targetIndex, itemCd) => {
				const currentLots = newLotMap.get(itemCd) || [];
				if (currentLots.length > targetIndex) {
					const targetList = currentLots.map((lot, index) => {
						if (index === targetIndex) {
							return { ...lot, lotQty: 0 };
						}
						return lot;
					});

					// 변경사항이 있을 때만 업데이트하여 무한루프 방지
					if (JSON.stringify(currentLots) !== JSON.stringify(targetList)) {
						newLotMap.set(itemCd, targetList);
						isUpdated = true;
					}
				}
			});

			if (isUpdated) {
				set({ KSK1070_R01LotMap: newLotMap });
				// 0으로 초기화 후 다시 계산을 위해 재귀 호출
				get().validateAndSyncLotQty();
				return;
			}
		}

		const needsUpdate = KSK1070_R01DetailList.some(detailItem => {
			const sum = lotQtySums.get(detailItem.itemCd);
			return sum !== undefined && detailItem.updateTransportQty !== sum;
		});

		const stateUpdates: Partial<Store_KSK1070_R01> = {};

		if (needsUpdate && valid) {
			stateUpdates.KSK1070_R01DetailList = KSK1070_R01DetailList.map(detailItem => {
				const sum = lotQtySums.get(detailItem.itemCd);
				if (sum !== undefined && detailItem.updateTransportQty !== sum) {
					return { ...detailItem, updateTransportQty: sum };
				}
				return detailItem;
			});
		}

		if (Object.keys(stateUpdates).length > 0) {
			set(stateUpdates);
		}
	},

}));
